/* agile-hover-slider.js */

document.addEventListener('DOMContentLoaded', () => {

    if (window.lucide) window.lucide.createIcons();

    const sections = document.querySelectorAll('.agile-hover-slider-section');
    sections.forEach(section => initAgileSlider(section));
});

function initAgileSlider(section) {

    const track = section.querySelector('.slw-carousel-track');
    const wrapper = section.querySelector('.slw-carousel-wrapper');
    const prevBtn = section.querySelector('.slw-nav-btn.prev');
    const nextBtn = section.querySelector('.slw-nav-btn.next');

    if (!track || !wrapper) return;

    let draggableInstance;
    let startX = 0;

    // -----------------------------------
    // Helpers
    // -----------------------------------

    function getWrapperPaddingLeft() {
        const style = getComputedStyle(wrapper);
        return parseFloat(style.paddingLeft) || 0;
    }

    function getBounds() {
        const trackWidth = track.scrollWidth;
        const wrapperWidth = wrapper.clientWidth;

        return {
            minX: wrapperWidth - trackWidth,
            maxX: 0
        };
    }

    function clamp(x) {
        const { minX, maxX } = getBounds();
        if (x > maxX) return maxX;
        if (x < minX) return minX;
        return x;
    }

    function updateNavButtons() {
        if (!prevBtn || !nextBtn) return;

        const currentX = gsap.getProperty(track, "x");
        const { minX } = getBounds();

        prevBtn.classList.toggle('hidden', currentX >= -5);
        nextBtn.classList.toggle('hidden', currentX <= minX + 5);
    }

    function getCards() {
        return Array.from(track.querySelectorAll('.slw-card'));
    }

    function getClosestIndex() {

        const cards = getCards();
        const wrapperRect = wrapper.getBoundingClientRect();
        const padding = getWrapperPaddingLeft();

        let closest = 0;
        let minDist = Infinity;

        cards.forEach((card, i) => {

            const rect = card.getBoundingClientRect();

            const dist = Math.abs(
                rect.left - (wrapperRect.left + padding)
            );

            if (dist < minDist) {
                minDist = dist;
                closest = i;
            }
        });

        return closest;
    }

    function moveToIndex(index, animate = true) {

        const cards = getCards();
        if (!cards[index]) return;

        const wrapperRect = wrapper.getBoundingClientRect();
        const padding = getWrapperPaddingLeft();
        const currentX = gsap.getProperty(track, "x");

        const rect = cards[index].getBoundingClientRect();

        const offset =
            rect.left - (wrapperRect.left + padding);

        const targetX = clamp(currentX - offset);

        if (animate) {
            gsap.to(track, {
                x: targetX,
                duration: 0.35,
                ease: "power2.out",
                onUpdate: updateNavButtons,
                onComplete: updateNavButtons
            });
        } else {
            gsap.set(track, { x: targetX });
            updateNavButtons();
        }
    }

    // -----------------------------------
    // Initial alignment (respects gap)
    // -----------------------------------

    function alignInitial() {
        requestAnimationFrame(() => {
            moveToIndex(0, false);
        });
    }

    // -----------------------------------
    // Draggable — Any drag = full slide
    // -----------------------------------

    if (typeof gsap !== 'undefined' && typeof Draggable !== 'undefined') {

        draggableInstance = Draggable.create(track, {
            type: "x",
            inertia: false,
            bounds: wrapper,
            edgeResistance: 0.9,
            dragClickables: false,

            onDragStart() {
                startX = this.x;
            },

            onDragEnd() {

                const delta = this.x - startX;

                if (Math.abs(delta) < 5) {
                    moveToIndex(getClosestIndex());
                    return;
                }

                const index = getClosestIndex();

                moveToIndex(
                    delta < 0 ? index + 1 : index - 1
                );
            },

            onDrag: updateNavButtons
        });
    }

    // -----------------------------------
    // Buttons
    // -----------------------------------

    nextBtn?.addEventListener('click', () => {
        moveToIndex(getClosestIndex() + 1);
    });

    prevBtn?.addEventListener('click', () => {
        moveToIndex(getClosestIndex() - 1);
    });

    // -----------------------------------
    // Resize
    // -----------------------------------

    const resizeObserver = new ResizeObserver(alignInitial);
    resizeObserver.observe(wrapper);

    // -----------------------------------
    // Video hover (unchanged)
    // -----------------------------------

    track.querySelectorAll('.slw-card').forEach(card => {

        const video = card.querySelector('video');

        if (video) {

            card.addEventListener('mouseenter', () => {
                if (draggableInstance?.[0]?.isDragging) return;
                video.play().catch(() => {});
            });

            card.addEventListener('mouseleave', () => {
                video.pause();
                video.currentTime = 0;
            });
        }
    });

    // Init
    alignInitial();
}
